import { useShogunchop } from '../../providers/ShogunChopProvider';

export function ShogunChopSection() {
  const { desktop } = useShogunchop();
  const connected = desktop.state === 'connected';

  return (
    <section className="space-y-4">
      <div>
        <h2 className="text-title-2 font-semibold">Local Device (ShogunChop)</h2>
        <p className="text-body text-muted-foreground">
          Detected via the bridge — devices currently connected for this account
        </p>
      </div>

      <div className="rounded-lg bg-card p-4 space-y-3">
        <div>
          <span className="text-label font-medium text-muted-foreground">Connection</span>
          <div
            data-testid="device-connection-status"
            className="mt-1 flex items-center gap-2"
          >
            <span
              className={`flex h-2 w-2 rounded-full ${connected ? 'bg-success' : 'bg-error'}`}
            />
            <span className="text-body">{connected ? 'Connected' : 'Not connected'}</span>
          </div>
        </div>

        {desktop.desktopDevices.length > 0 && (
          <div data-testid="shogunchop-device-info" className="space-y-2">
            {desktop.desktopDevices.map((device) => (
              <div key={device.device_id} className="space-y-1 pt-2 first:pt-0">
                <div>
                  <span className="text-label font-medium text-muted-foreground">Device ID</span>
                  <code className="mt-1 block rounded bg-muted px-2 py-1 text-body">{device.device_id}</code>
                </div>
                <div>
                  <span className="text-label font-medium text-muted-foreground">Connected at</span>
                  <code className="mt-1 block rounded bg-muted px-2 py-1 text-body">
                    {new Date(device.connected_at).toLocaleString()}
                  </code>
                </div>
                <div>
                  <span className="text-label font-medium text-muted-foreground">Last heartbeat</span>
                  <code className="mt-1 block rounded bg-muted px-2 py-1 text-body">
                    {new Date(device.last_heartbeat).toLocaleString()}
                  </code>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
